import {
  TGetNewbuildingsForDeveloperCardResponse_1,
  IGetNewbuildingsForDeveloperCardResponse200,
  IGetNewbuildingsForDeveloperCardResponse400,
  TGetNewbuildingsForDeveloperCardResponseError,
} from '../repositories/newbuilding-search/v1/get-newbuildings-for-developer-card';

export function mapNewbuildingResponse(
  response: TGetNewbuildingsForDeveloperCardResponse_1,
): IGetNewbuildingsForDeveloperCardResponse200 {
  return {
    headers: [],
    statusCode: 200,
    response: {
      jsonQuery: response.jsonQuery,
      newbuildings: response.newbuildings,
      newbuildingCounts: response.newbuildingCounts,
    },
  };
}

export function mapNewbuildingResponseError(
  response: TGetNewbuildingsForDeveloperCardResponseError,
): IGetNewbuildingsForDeveloperCardResponse400 {
  return {
    statusCode: 400,
    headers: [],
    response: {
      errors: response.errors,
      message: response.message,
    },
  };
}
